// Anonymous click counter (audience measurement exempt from consent, AEPD guide Jan 2024).
//
// Counts a few user actions and sends ONE small ping per action to our own /_m/c endpoint
// (a Netlify Edge Function that adds the country and forwards it to our hub):
//   { action, detail, page, source, medium, campaign }
// Actions: try_free (any "Try for free"/"Sign up" link to console.graphenedb.com/signup),
//          console (the header "Console" button, which also leads to sign-up but is used by customers too),
//          contact_open (a "Contact sales"/"Contact us" button), contact_sent (contact form sent; detail demo/general).
// - No cookies, no localStorage/sessionStorage: the visit's source is kept in memory only, so it
//   survives Gatsby's in-app navigation but is gone on reload or a new visit.
// - No identifiers: ad click IDs (gclid, twclid…) are never read or sent; their presence only
//   labels the source ("google / cpc", "x / paid").
// - The hub stores daily totals per page, source and country, deleted after 25 months.

const ENDPOINT = "/_m/c"
const SIGNUP = /(^|\.)console\.graphenedb\.com$/

let attribution = null

function captureAttribution() {
  const params = new URLSearchParams(window.location.search)
  let source = params.get("utm_source")
  let medium = params.get("utm_medium")
  const campaign = params.get("utm_campaign")
  if (!source && params.has("gclid")) {
    source = "google"
    medium = "cpc"
  }
  if (!source && params.has("twclid")) {
    source = "x"
    medium = "paid"
  }
  if (!source && document.referrer) {
    try {
      const host = new URL(document.referrer).hostname.replace(/^www\./, "")
      if (!/(^|\.)graphenedb\.com$/.test(host)) source = host
    } catch (e) {
      // ignore unparsable referrers
    }
  }
  attribution = {
    source: source || "direct",
    medium: medium || "",
    campaign: campaign || "",
  }
}

function isSignupLink(anchor) {
  try {
    const url = new URL(anchor.href, window.location.href)
    return SIGNUP.test(url.hostname) && url.pathname.replace(/\/+$/, "") === "/signup"
  } catch (e) {
    return false
  }
}

function send(action, detail = "") {
  if (!attribution) return
  const body = JSON.stringify({ action, detail, page: window.location.pathname, ...attribution })
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" }))
      return
    }
  } catch (e) {
    // fall through to fetch
  }
  fetch(ENDPOINT, { method: "POST", body, keepalive: true, headers: { "Content-Type": "text/plain" } }).catch(() => {})
}

const CONTACT = /^\s*contact (sales|us)\s*$/i

export function startSignupCounter() {
  if (typeof window === "undefined" || attribution) return
  captureAttribution()
  document.addEventListener(
    "click",
    event => {
      const el = event.target && event.target.closest ? event.target.closest("a, button") : null
      if (!el) return
      if (el.matches("a[href]") && isSignupLink(el)) {
        send(el.classList.contains("menu-nav-button") ? "console" : "try_free")
      } else if (CONTACT.test(el.textContent || "")) {
        send("contact_open")
      }
    },
    true
  )
}

/** Called by the contact form after it was sent successfully. Only the request type is counted, never the content. */
export function countContactSent(requestType) {
  send("contact_sent", /demo/i.test(requestType || "") ? "demo" : "general")
}
